<template>
  <div class="flex flex-dir-column app-layout orver-hidden-x" v-loading="queryLoading">
    <!-- 顶部搜索的表单 -->
    <div class="top-search">
      <el-form
        align="left"
        size="small"
        ref="topForm"
        :model="formQuery"
        label-width="80px"
        :inline="true"
        class="padding-left-20"
      >
        <el-form-item label="时间范围">
          <el-date-picker v-model="formQuery.range" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" align="right" unlink-panels
            :clearable="false" @change="queryPageInfo"></el-date-picker>
        </el-form-item>
        <el-form-item label="页面" required>
          <el-select v-model="formQuery.pagePath" filterable placeholder="请选择页面"
            @change="handlePageChange">
            <el-option v-for="item in pageInfos" :key="item.pagePath"
              :value="`${item.pagePath}(${item.pageName})`">
              <template v-if="item.pagePath.length < 60">
                {{ item.pagePath }}
                <template v-if="item.pageName">({{ item.pageName }})</template>
              </template>
              <el-tooltip v-else effect="light" :content="`${item.pagePath}(${item.pageName})`"
                placement="right">
                <p>
                  {{ item.pagePath.slice(0, 60) }}...
                  <template v-if="item.pageName">({{ item.pageName }})</template>
                </p>
              </el-tooltip>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系统">
          <el-select @change="osInfosChange" v-model="formQuery.os" placeholder="请选择系统">
            <el-option v-for="item in osInfos" :key="item.os" :label="item.os"
              :value="item.value === undefined ? item.os : item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本">
          <el-select @change="handleQueryData" v-model="formQuery.osVersion" placeholder="请选择版本"
            clearable>
            <el-option v-for="(item, index) in osVersions" :key="`osVersion-${index}`"
              :label="item.os === undefined ? item : item.os"
              :value="item.value === undefined ? item : item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button size="small" type="primary" @click="handleQueryData">查询</el-button>
      </el-form>
    </div>
    <el-card class="flex-1 box-card box-card-echart" shadow="never"
      :body-style="{ padding: '0 20px' }">
      <!-- 顶部各种总数据，还未传参 -->
      <el-card class="box-card" shadow="never">
        <totalData :data="eventCountData"></totalData>
      </el-card>
      <el-row :gutter="20">
        <!-- 事件TOP10 -->
        <el-col :span="12">
          <el-card class="box-card" shadow="never">
            <div class="page-analysis-item">
              <div class="title">事件TOP</div>
              <top-form @change="
                  (topCount) => {
                    formEventQuery.topCount = topCount;
                    queryPageTopData(1);
                  }
                "></top-form>
              <Echart isMountedRender :id="'EventTOP'" :data="chartData" :xType="'value'"
                :yType="'category'" :xShow="false" :showData="true" :type="'bar'"></Echart>
            </div>
          </el-card>
        </el-col>
        <!-- 用户TOP -->
        <el-col :span="12">
          <el-card class="box-card" shadow="never">
            <div class="page-analysis-item">
              <div class="title">用户TOP</div>
              <top-form @change="
                  (topCount) => {
                    formUserQuery.topCount = topCount;
                    queryPageTopData(2);
                  }
                "></top-form>
              <Echart isMountedRender :id="'userTop'" :data="chartData2" :islinePlie="true">
              </Echart>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row>
        <!-- 数据对比 -->
        <el-col :span="24">
          <el-card class="box-card" shadow="never">
            <div class="page-analysis-item">
              <div class="title">数据对比</div>
              <div class="dataComparison-form">
                <el-form ref="dataComparisonForm" :model="dataComparisonData" label-width="40px"
                  :inline="dataComparisonData.userName.length < 8">
                  <el-form-item label="事件">
                    <el-select style="width: 400px;" v-model="formQuery.eventCode" filterable
                      placeholder="请选择事件" @change="handleEventChange">
                      <el-option v-for="item in pageEvents" :key="item.eventCode" :label="
                          item.eventName ? `${item.eventName}(${item.eventCode})` : item.eventCode
                        " :value="`${item.eventCode}(${item.eventName})`">
                        <!-- <el-tooltip effect="light" :content="item.eventCode" placement="right">
                          <p>{{ item.eventCode.slice(0, 100) }}</p>
                        </el-tooltip> -->
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <Echart isMountedRender ref="userConEchart" :id="'userCondition'" :data="chartData3"
                isMultipleX></Echart>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Moment from 'moment';
import {
  queryPageInfo,
  queryPageEventTop,
  queryPageUserTop,
  queryPageCount,
  queryPageCountTendency,
  queryPageEvent,
} from '@/api/page-analyze';
import { queryOsInfo } from '@/api/event';
import Echart from '@/views/components/echart/index.vue';
import totalData from '@/views/event-manage/component/total-data/index.vue';
import topForm from '@/views/event-manage/component/top-form/index.vue';

export default {
  components: { totalData, topForm, Echart },
  computed: {
    ...mapGetters('app', ['env', 'source']),
  },
  data() {
    return {
      //   数据对比表单数据
      dataComparisonData: {
        event: '',
        userName: [''],
        browser: '',
        dateScopeTypeOne: '1',
        dateScopeOne: [],
        dateScopeTypeTwo: '1',
        dateScopeTwo: [],
      },
      // 以下test数据作为给不同图传的数据格式示例
      chartData: {
        x: ['暂无数据'],
        y: ['0'],
      },
      chartData2: {
        x: [0],
        y: [{ name: '暂无数据', data: [0] }],
      },
      chartData3: {
        legend: ['选中时间段', '对比时间段'],
        x: [
          {
            data: [0],
          },
          {
            data: [0],
          },
        ],
        y: [
          {
            name: '选中时间段',
            data: [],
          },
          {
            name: '对比时间段',
            data: [],
          },
        ],
      },
      //   各种下拉框选项列表
      events: [
        { label: '确认下单', value: '1' },
        { label: '事件2', value: '2' },
      ],
      systems: [
        { label: 'web', value: 'web' },
        { label: 'app', value: 'app' },
      ],
      versions: [
        { label: 'v1.0', value: '1.0' },
        { label: 'v1.0', value: '1.1' },
      ],
      browsers: [
        { label: 'v1.0', value: '1.0' },
        { label: 'v1.0', value: '1.1' },
      ],
      dateScope: [{ label: '自定义', value: '1' }],
      formQuery: {
        range: [],
        pagePath: '',
        osVersion: '',
        eventCode: '',
        os: '',
      },
      formEventQuery: {
        topCount: 10,
      },
      formUserQuery: {
        topCount: 10,
      },
      pageEvents: [],
      queryLoading: false,
      osInfos: [],
      osVersions: [],
      pageInfos: [],
      eventCountData: [
        { name: '事件总次数(PV)', data: 0 },
        { name: '用户数(uv)', data: 0 },
      ],
    };
  },
  mounted() {
    const today = Moment().format('YYYY-MM-DD');
    const today2 = Moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.formQuery.range = [new Date(today2), new Date(today)];
    this.queryPageInfo();
    this.queryOsInfo();
  },
  watch: {
    source: {
      handler() {
        this.formQuery.pagePath = '';
        this.queryPageInfo();
        this.queryOsInfo();
      },
    },
    env: {
      handler() {
        this.queryPageInfo();
        this.queryOsInfo();
      },
    },
  },
  methods: {
    resetChartData(type) {
      const { range } = this.formQuery;
      const analyzeTimeTo = Moment(range[1]).format('YYYY-MM-DD');
      const analyzeTimeFrom = Moment(range[0]).format('YYYY-MM-DD');
      // eslint-disable-next-line operator-linebreak
      const days =
        Moment(analyzeTimeTo).diff(Moment(analyzeTimeFrom), 'days') + 1;

      if (type === 1) {
        this.chartData.x.splice(0, this.chartData.x.length, '暂无数据');
        this.chartData.y.splice(0, this.chartData.y.length, 0);
      }
      if (type === 2) {
        const xList = [];
        const yList = [];
        // 计算相差多少天
        for (let i = 0, len = days; i < len; i++) {
          xList.push(
            // eslint-disable-next-line comma-dangle
            Moment(analyzeTimeFrom).subtract(i, 'days').format('YYYY-MM-DD')
          );
          yList.push({
            name: '暂无数据',
            data: [0],
          });
          // yList[i].data.push(0);
        }

        this.chartData2.x.splice(0, this.chartData2.x.length, ...xList);
        this.chartData2.y.splice(0, this.chartData2.y.length, ...yList);
        return;
      }
      if (type === 3) {
        const xList = [
          {
            data: [],
          },
          {
            data: [],
          },
        ];
        const yList = [
          {
            name: '对比时间段',
            data: [],
          },
          {
            name: '选中时间段',
            data: [],
          },
        ];
        // 计算相差多少天
        for (let i = 0, len = days; i < len; i++) {
          xList[0].data.push(
            // eslint-disable-next-line comma-dangle
            Moment(analyzeTimeFrom).subtract(i, 'days').format('YYYY-MM-DD')
          );
          xList[1].data.push(
            // eslint-disable-next-line comma-dangle
            Moment(analyzeTimeTo).subtract(i, 'days').format('YYYY-MM-DD')
          );
          yList[0].data.push(0);
          yList[1].data.push(0);
        }

        this.chartData3.x.splice(0, this.chartData3.x.length, ...xList);
        this.chartData3.y.splice(0, 2, ...yList);
        this.chartData3.legend = ['选中时间段', '对比时间段'];
      }
    },
    handleEventChange() {
      // this.formQuery.eventCode = this.formQuery.eventCode.replace(/(\(.+\))/g, '');
      this.queryPageTopData(3);
    },
    handlePageChange() {
      // this.formQuery.pagePath = this.formQuery.pagePath.replace(/(\(.+\))/g, '');
      this.handleQueryData();
    },
    async queryPageTopData(type) {
      // eslint-disable-next-line object-curly-newline
      const { range, osVersion, os, pagePath } = this.formQuery;
      const data = {
        pagePath: pagePath?.replace(/(\(.+\))/g, ''),
        analyzeTimeTo: Moment(range[1]).format('YYYY-MM-DD'),
        analyzeTimeFrom: Moment(range[0]).format('YYYY-MM-DD'),
        osVersion,
        os,
      };

      switch (type) {
        case 1:
          this.queryPageEventTop(data);
          break;
        case 2:
          this.queryPageUserTop(data);
          break;
        case 3:
          this.queryPageCountTendency(data);
          break;
        default:
          break;
      }
    },
    async queryPageCountTendency(params) {
      this.queryLoading = true;
      try {
        const { eventCode } = this.formQuery;

        const { analyzeTimeTo, analyzeTimeFrom } = params;
        // eslint-disable-next-line operator-linebreak
        const days =
          Moment(analyzeTimeTo).diff(Moment(analyzeTimeFrom), 'days') + 1;

        const {
          data: { pageCounts },
        } = await queryPageCountTendency({
          ...params,
          referAnalyzeTime: Moment(analyzeTimeFrom)
            .subtract(days, 'days')
            .format('YYYY-MM-DD'),
          eventCode: eventCode?.replace(/(\(.+\))/g, ''),
        });

        const xList = [
          {
            data: [],
          },
          {
            data: [],
          },
        ];
        const yList = [
          {
            name: '对比时间段',
            data: [],
          },
          {
            name: '选中时间段',
            data: [],
          },
        ];

        if (!pageCounts.length) {
          this.resetChartData(3);
        } else {
          // eslint-disable-next-line object-curly-newline
          pageCounts.forEach(
            // eslint-disable-next-line object-curly-newline
            ({ currentAnalyzeTime, referAnalyzeTime, current, refer }) => {
              xList[0].data.push(currentAnalyzeTime);
              xList[1].data.push(referAnalyzeTime);
              yList[0].data.push(refer);
              yList[1].data.push(current);
              // eslint-disable-next-line comma-dangle
            }
          );

          this.chartData3.x.splice(0, this.chartData3.x.length, ...xList);
          this.chartData3.y.splice(0, 2, ...yList);
          this.chartData3.legend = ['选中时间段', '对比时间段'];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryPageUserTop(params) {
      this.queryLoading = true;
      try {
        const { topCount } = this.formUserQuery;

        const {
          data: { pageUserTops },
        } = await queryPageUserTop({ ...params, topCount });

        const xList = [];
        const yList = [];
        if (!pageUserTops.length) {
          this.resetChartData(2);
        } else {
          pageUserTops[0]?.pageCountTendencies.forEach(({ analyzeTime }) => {
            xList.push(analyzeTime);
          });
          pageUserTops.forEach(({ userName, pageCountTendencies }, index) => {
            yList.push({
              name: userName,
              data: [],
            });
            pageCountTendencies.forEach(({ count }) => {
              yList[index].data.push(count);
            });
          });

          this.chartData2.x.splice(0, this.chartData2.x.length, ...xList);
          this.chartData2.y.splice(0, this.chartData2.y.length, ...yList);
        }
        // chartData: {
        //   x: [1, 2, 3, 4, 5, 6],
        //   y: [{ name: '测试1', data: [2, 3, 4, 5, 6] },
        //     { name: '测试2', data: [4, 2, 1, 9, 10] },],
        // },
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryPageEventTop(data) {
      this.queryLoading = true;
      try {
        const { topCount } = this.formEventQuery;

        const {
          data: { pageEventTops },
        } = await queryPageEventTop({ ...data, topCount });

        const xList = [];
        const yList = [];

        if (!pageEventTops.length) {
          this.resetChartData(1);
        } else {
          pageEventTops.reverse();
          pageEventTops.forEach(({ eventCode, eventName, count }) => {
            const code = eventCode;
            // .split('').map((item, index) => (!((index + 1) % 10) ? `${item}\n` : item)).join('');
            xList.push(eventName ? `${eventName}\n${code}` : `${code}`);
            yList.push(count);
          });

          this.chartData.x.splice(0, this.chartData.x.length, ...xList);
          this.chartData.y.splice(0, this.chartData.y.length, ...yList);
        }
        // chartData: {
        //   x: [1, 2, 3, 4, 5, 6],
        //   y: [{ name: '测试1', data: [2, 3, 4, 5, 6] },
        //     { name: '测试2', data: [4, 2, 1, 9, 10] },],
        // },
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryOsInfo() {
      this.queryLoading = true;
      try {
        const { range } = this.formQuery;
        const data = {
          analyzeTimeTo: Moment(range[1]).format('YYYY-MM-DD'),
          analyzeTimeFrom: Moment(range[0]).format('YYYY-MM-DD'),
        };
        const {
          data: { osInfos },
        } = await queryOsInfo(data);
        this.osInfos.splice(
          0,
          this.osInfos.length,
          // eslint-disable-next-line comma-dangle
          ...[{ os: '全部', value: '' }, ...osInfos]
        );

        this.formQuery.os = '';
        this.osInfosChange();
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    osInfosChange() {
      const filterData = this.osInfos.filter(
        // eslint-disable-next-line comma-dangle
        (item) => item.os === this.formQuery.os
      );

      const [{ osVersions = [] }] = filterData.length
        ? filterData
        : [{ osVersions: [] }];

      this.formQuery.osVersion = '';
      this.osVersions.splice(
        0,
        this.osVersions.length,
        // eslint-disable-next-line comma-dangle
        ...[{ os: '全部', value: '' }, ...osVersions]
      );

      this.handleQueryData();
    },
    async handleQueryData() {
      this.queryLoading = true;
      try {
        // eslint-disable-next-line object-curly-newline
        const { range, osVersion, os, pagePath } = this.formQuery;

        if (!pagePath) {
          return;
        }

        const data = {
          analyzeTimeTo: Moment(range[1]).format('YYYY-MM-DD'),
          analyzeTimeFrom: Moment(range[0]).format('YYYY-MM-DD'),
          osVersion,
          os,
          pagePath: pagePath?.replace(/(\(.+\))/g, ''),
        };
        const {
          data: { eventCount, userCount },
        } = await queryPageCount(data);
        this.eventCountData[0].data = eventCount;
        this.eventCountData[1].data = userCount;

        // this.queryChartData();
        this.queryPageTopData(1);
        this.queryPageTopData(2);
        // this.queryPageTopData(3);
        this.queryPageEvent(data);
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryPageEvent(data) {
      this.queryLoading = true;
      try {
        const {
          data: { pageEvents },
        } = await queryPageEvent(data);

        const { eventCode, eventName } = pageEvents[0] || {};
        this.pageEvents.splice(0, this.pageEvents.length, ...pageEvents);
        this.formQuery.eventCode = eventName
          ? `${eventCode}(${eventName})`
          : eventCode;
        this.queryPageTopData(3);
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryPageInfo() {
      this.queryLoading = true;
      try {
        const { range } = this.formQuery;
        const data = {
          analyzeTimeTo: Moment(range[1]).format('YYYY-MM-DD'),
          analyzeTimeFrom: Moment(range[0]).format('YYYY-MM-DD'),
        };
        const {
          data: { pageInfos },
        } = await queryPageInfo(data);

        if (!this.formQuery.pagePath) {
          this.formQuery.pagePath = pageInfos[0]?.pagePath || '';
        }
        this.pageInfos.splice(0, this.pageInfos.length, ...pageInfos);

        if (!pageInfos.length) {
          this.resetChartData(1);
          this.resetChartData(2);
          this.resetChartData(3);
        } else {
          this.handleQueryData();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box-card {
  text-align: left;
  margin-bottom: 20px;
  &-echart {
    background: transparent;
    // max-height: 400px;
    overflow: auto;
  }
}
.app-layout {
  height: calc(100vh - 0);
  min-width: 800px;
  margin: 15px 0 0;
}
// .top-search {
//   position: fixed;
//   top: 95px;
//   left: 15px;
//   right: 15px;
//   padding: 30px 20px 0;
//   background: #fff;
//   z-index: 99;
//   text-align: left;
//   border-radius: 5px;
// }
.page-analysis-item {
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
.choose-btn {
  margin-left: 80px;
  margin-bottom: 20px;
}
.condition {
  display: flex;
  flex-wrap: wrap;
  // max-width: 1000px;
  .el-input {
    margin-right: 10px;
    width: 130px;
    min-width: 130px;
  }
  .el-button {
    margin-right: 10px;
    font-size: 20px;
  }
}
.scope {
  display: flex;
  align-items: center;
  .vs {
    margin: 0 15px;
    background-color: rgb(54, 115, 232);
    height: 24px;
    width: 24px;
    line-height: 24px;
    text-align: center;
    color: #fff;
    border-radius: 100%;
  }
}
</style>
